import "./shortTextCell.css"
export function ShortTextCell({text}) {

    return (
      <td > <p className="short-text">{text}</p></td>
    )
}